<script>
import LoadingRingAlt from '../LoadingRingAlt';
import Sounds from '../../../../core/sounds/Sounds';
export default {
  name: 'DefaultNotification',
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'warning',
    },
    soundEnable: {
      type: Boolean,
      default: true,
    },
    sound: {
      type: String,
      default: 'notification',
    },
    interactable: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 0,
    },
  },
  components: {
    LoadingRingAlt,
  },
  created () {
    if (this.soundEnable) Sounds[this.sound]();
    if (this.duration) {
      this.__notificationTimeout = setTimeout(() => this.$store.dispatch('nextNotification'), this.duration);
    }
  },
  destroyed () {
    if (this.__notificationTimeout) {
      clearTimeout(this.__notificationTimeout);
    }
  },
};
</script>

<template lang="pug">
div.notification.b--green.ba.bg-black-dark-overlay.tc.pa3.relative(:class="{ '_collision': interactable }")
  p.fw6.f7.white.tc.lh-copy
    icon.mr2.w1.fill-green.v-mid(name="warning", v-if="type === 'warning'")
    icon.mr2.w1.fill-green.v-mid(name="x", v-if="type === 'error'")
    loading-ring-alt.mr2.w1.b--green.v-mid.dib(name="warning", v-if="type === 'loading'")
    | {{ message }}

</template>

<style scoped lang="postcss">
.notification {
  max-width: 40rem;
}
</style>
